<ng-container *ngIf="hasLink">
  <button mat-icon-button matTooltip="Contact / Help" routerLink="/help" routerLinkActive="hidden">
    <mat-icon>help_outline</mat-icon>
  </button>
</ng-container>
